export const calculatePayment = (
  loanAmount: number,
  interestRate: number,
  months: number,
  fixedValue: number
) => {
  const monthlyInterestRate = interestRate / 12 / 100;
  const payment =
    (loanAmount * monthlyInterestRate) /
    (1 - (1 + monthlyInterestRate) ** -months);
  const parsedPayment = parseFloat(payment.toFixed(fixedValue));

  const formattedNumber = new Intl.NumberFormat('en-US').format(parsedPayment);

  return formattedNumber;
};
